// extracted by mini-css-extract-plugin
module.exports = {"dot":"dot_dot__-SjqP","selected":"dot_selected__1CyXT"};